import { atom } from 'recoil';
export const fieldsDialogAtom = atom({
    key: 'dialogs/fields',
    default: {},
});
export const alertDialogAtom = atom({
    key: 'dialogs/alert',
    default: {},
});
export const scrollToFieldAtom = atom({
    key: 'dialogs/scrollToField',
    default: null,
});
